module.exports = __webpack_public_path__ + "img/china_unicom_icon.7b31ad4b.svg";